import EventEmitter from 'event-emitter-es6';



export const eventEmitter = new EventEmitter();